import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const PriceBlockWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    flexShrink: 0,
}));

export const StrikeOffText = styled(Text)(() => ({
    textDecoration: "line-through",
    whiteSpace: "nowrap",
}));

export const FinalText = styled(Text)(() => ({
    whiteSpace: "nowrap",
}));

export const FreeDeliveryText = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xxxSmall,
}));
